import styled from 'styled-components'

import { tableCss, mediaPrintRemoveMargPaddBackg } from '../../styles'

export const TableDiv = styled.div`
  ${mediaPrintRemoveMargPaddBackg}
  ${tableCss}
`

export const Spacer = styled.div`
  padding-bottom: 20px;
`
